// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.folderIndicator_C9o4Z {
  border-radius: 8px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  max-width: 100%;
  animation: slideIn_s2W7z_aRW31 0.3s ease-out;
}

.indicatorContent_O4USX {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  gap: 12px;
}

.folderInfo_mLCsA {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
}

.folderIcon_xBW9M,
.fileIcon_XNPP8 {
  font-size: 14px;
  flex-shrink: 0;
}

.folderPath_tJMGD {
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.separator_cRX50 {
  color: #d1d5db;
  font-size: 12px;
  flex-shrink: 0;
}

.fileName_AImYL {
  color: #1f2937;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fileType_Zr_zU {
  color: #6b7280;
  font-size: 11px;
  font-style: italic;
  flex-shrink: 0;
}

.selectedLines_ws8gQ {
  color: #3b82f6;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
  background: #eff6ff;
  padding: 1px 4px;
  border-radius: 3px;
  border: 1px solid #dbeafe;
  animation: highlightIn_dcmoK 0.2s ease-in;
}

.actions_x__5I {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chatButton_uO37m {
  padding: 4px 8px;
  border: 1px solid #10b981;
  background: #10b981;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.chatButton_uO37m:hover {
  background: #059669;
  border-color: #059669;
  transform: scale(1.02);
}

.chatButton_uO37m:active {
  transform: scale(0.98);
}

.chatButton_uO37m:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.noAgentMessage_dCBr0 {
  padding: 4px 8px;
  border: 1px solid #f59e0b;
  background: #fef3c7;
  color: #92400e;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  cursor: help;
  opacity: 0.8;
}

.addDocumentButton_MwS0c {
  padding: 4px 8px;
  border: 1px solid #3b82f6;
  background: #3b82f6;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.addDocumentButton_MwS0c:hover {
  background: #2563eb;
  border-color: #2563eb;
  transform: scale(1.02);
}

.addDocumentButton_MwS0c:active {
  transform: scale(0.98);
}

.addDocumentButton_MwS0c:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.openChatButton_r0FnJ {
  padding: 4px 8px;
  border: 1px solid #3b82f6;
  background: #3b82f6;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.openChatButton_r0FnJ:hover {
  background: #2563eb;
  border-color: #2563eb;
  transform: scale(1.02);
}

.openChatButton_r0FnJ:active {
  transform: scale(0.98);
}

.openChatButton_r0FnJ:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.successMessage_xiGFI {
  padding: 4px 8px;
  background: #10b981;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  animation: fadeIn_OuCx0 0.3s ease-in;
}

.closeButton_NoT5M {
  width: 24px;
  height: 24px;
  border: none;
  background: #f3f4f6;
  color: #6b7280;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

.closeButton_NoT5M:hover {
  background: #e5e7eb;
  color: #374151;
  transform: scale(1.05);
}

.closeButton_NoT5M:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}


.actionsList_Rh1wD {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  flex-direction: column;
  gap: 2px;

  .actionItem_mHhLC {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;

    .actionIcon_hfBJK {
      font-size: 12px;
      flex-shrink: 0;
    }

    .actionName_jMa5d {
      font-size: 14px;
      margin: 0;
    }

    .actionCategory_oKRlj {
      font-size: 12px;
      color: #6b7280;
    }
  }
}


@keyframes slideIn_s2W7z {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn_OuCx0 {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes highlightIn_dcmoK {
  from {
    opacity: 0;
    transform: scale(0.8);
    background: #dbeafe;
  }

  to {
    opacity: 1;
    transform: scale(1);
    background: #eff6ff;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .folderIndicator_C9o4Z {
    margin: 0 10px;
  }

  .indicatorContent_O4USX {
    padding: 10px 12px;
  }

  .folderPath_tJMGD,
  .fileName_AImYL {
    font-size: 12px;
  }

  .fileType_Zr_zU {
    font-size: 10px;
  }

  .addDocumentButton_MwS0c {
    padding: 3px 6px;
    font-size: 10px;
  }

  .actions_x__5I {
    gap: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/FileExplorer/FolderIndicator.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,4CAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oCAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;;EAER;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;;IAEzB;MACE,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,eAAe;MACf,SAAS;IACX;;IAEA;MACE,eAAe;MACf,cAAc;IAChB;EACF;AACF;;;AAGA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA,eAAe;AACf;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":[".folderIndicator {\n  border-radius: 8px;\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\n  max-width: 100%;\n  animation: slideIn_s2W7z 0.3s ease-out;\n}\n\n.indicatorContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 10px;\n  gap: 12px;\n}\n\n.folderInfo {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.folderIcon,\n.fileIcon {\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.folderPath {\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.separator {\n  color: #d1d5db;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.fileName {\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fileType {\n  color: #6b7280;\n  font-size: 11px;\n  font-style: italic;\n  flex-shrink: 0;\n}\n\n.selectedLines {\n  color: #3b82f6;\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n  background: #eff6ff;\n  padding: 1px 4px;\n  border-radius: 3px;\n  border: 1px solid #dbeafe;\n  animation: highlightIn 0.2s ease-in;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chatButton {\n  padding: 4px 8px;\n  border: 1px solid #10b981;\n  background: #10b981;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.chatButton:hover {\n  background: #059669;\n  border-color: #059669;\n  transform: scale(1.02);\n}\n\n.chatButton:active {\n  transform: scale(0.98);\n}\n\n.chatButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.noAgentMessage {\n  padding: 4px 8px;\n  border: 1px solid #f59e0b;\n  background: #fef3c7;\n  color: #92400e;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  cursor: help;\n  opacity: 0.8;\n}\n\n.addDocumentButton {\n  padding: 4px 8px;\n  border: 1px solid #3b82f6;\n  background: #3b82f6;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.addDocumentButton:hover {\n  background: #2563eb;\n  border-color: #2563eb;\n  transform: scale(1.02);\n}\n\n.addDocumentButton:active {\n  transform: scale(0.98);\n}\n\n.addDocumentButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.openChatButton {\n  padding: 4px 8px;\n  border: 1px solid #3b82f6;\n  background: #3b82f6;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.openChatButton:hover {\n  background: #2563eb;\n  border-color: #2563eb;\n  transform: scale(1.02);\n}\n\n.openChatButton:active {\n  transform: scale(0.98);\n}\n\n.openChatButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.successMessage {\n  padding: 4px 8px;\n  background: #10b981;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  animation: fadeIn 0.3s ease-in;\n}\n\n.closeButton {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: #f3f4f6;\n  color: #6b7280;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 10;\n}\n\n.closeButton:hover {\n  background: #e5e7eb;\n  color: #374151;\n  transform: scale(1.05);\n}\n\n.closeButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n\n.actionsList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 2px;\n\n  .actionItem {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    .actionIcon {\n      font-size: 12px;\n      flex-shrink: 0;\n    }\n\n    .actionName {\n      font-size: 14px;\n      margin: 0;\n    }\n\n    .actionCategory {\n      font-size: 12px;\n      color: #6b7280;\n    }\n  }\n}\n\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes highlightIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n    background: #dbeafe;\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n    background: #eff6ff;\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .folderIndicator {\n    margin: 0 10px;\n  }\n\n  .indicatorContent {\n    padding: 10px 12px;\n  }\n\n  .folderPath,\n  .fileName {\n    font-size: 12px;\n  }\n\n  .fileType {\n    font-size: 10px;\n  }\n\n  .addDocumentButton {\n    padding: 3px 6px;\n    font-size: 10px;\n  }\n\n  .actions {\n    gap: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"folderIndicator": `folderIndicator_C9o4Z`,
	"slideIn_s2W7z": `slideIn_s2W7z_aRW31`,
	"indicatorContent": `indicatorContent_O4USX`,
	"folderInfo": `folderInfo_mLCsA`,
	"folderIcon": `folderIcon_xBW9M`,
	"fileIcon": `fileIcon_XNPP8`,
	"folderPath": `folderPath_tJMGD`,
	"separator": `separator_cRX50`,
	"fileName": `fileName_AImYL`,
	"fileType": `fileType_Zr_zU`,
	"selectedLines": `selectedLines_ws8gQ`,
	"highlightIn": `highlightIn_dcmoK`,
	"actions": `actions_x__5I`,
	"chatButton": `chatButton_uO37m`,
	"noAgentMessage": `noAgentMessage_dCBr0`,
	"addDocumentButton": `addDocumentButton_MwS0c`,
	"openChatButton": `openChatButton_r0FnJ`,
	"successMessage": `successMessage_xiGFI`,
	"fadeIn": `fadeIn_OuCx0`,
	"closeButton": `closeButton_NoT5M`,
	"actionsList": `actionsList_Rh1wD`,
	"actionItem": `actionItem_mHhLC`,
	"actionIcon": `actionIcon_hfBJK`,
	"actionName": `actionName_jMa5d`,
	"actionCategory": `actionCategory_oKRlj`,
	"slideIn": `slideIn_s2W7z`
};
export default ___CSS_LOADER_EXPORT___;
